var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.counters,
            stripe: "",
            border: "",
            "show-header": false
          }
        },
        [
          _c("el-table-column", { attrs: { prop: "label", width: "150" } }),
          _vm._v(" "),
          _c("el-table-column", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__("Type") + " : " + scope.row.exemple
                        ) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "aright" },
                      [
                        _c("CompassButton", {
                          attrs: {
                            label: _vm.$t.__("common.actions.edit"),
                            type: "secondary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.spawnDialog(
                                scope.row.id,
                                scope.row.label
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.dialogVisible && _vm.counterStep == ""
        ? _c("counter-form", {
            attrs: {
              "counter-id": _vm.counterId,
              glues: _vm.glues,
              "date-formats": _vm.dateFormats,
              "ident-styles": _vm.identStyles,
              label: _vm.counterLabel
            },
            on: { "close-popup": _vm.closeDialog }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogVisible && _vm.counterStep == "draft"
        ? _c("counter-draft-form", {
            attrs: {
              "counter-id": _vm.counterId,
              glues: _vm.glues,
              "ident-styles": _vm.identStyles,
              label: _vm.counterLabel
            },
            on: { "close-popup": _vm.closeDialog }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }